import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
//context
import { UserContext } from "../../contexts/UserContext";
//css
import "./Homepage.css";
//loader
import FetchLoader from "../../helpers/FetchLoader";

export default function LocationSelector({ authToken }) {
  const { userSsoId } = useContext(UserContext);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryId, setCountryId] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    if (authToken)
      axios.get(process.env.REACT_APP_API_URL + "/v1/locations", {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            const locationList = response.data.map((location) => {
              return {
                ...location,
                value: location.locationName,
                label: location.locationName,
              };
            });
            setLocations(locationList);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching locations:", error);
        });
  }, [authToken]);

  const handleCountryChange = (event) => {
    setSelectedCountry(event.locationName);
    setCountryId(event.locationId);
  };

  const handleContinue = () => {
    if (selectedCountry) {
      setShowLoader(true);
      navigate("/devices", { state: { country: selectedCountry, countryId: countryId, userSsoId: userSsoId, authToken: authToken } });
    }
  };

  return (
    <div className="container">
      <div className="card">
        {isLoading
          ?
          <>
            <div className="skeleton-title skeleton-animation"></div>
            <div className="skeleton-text-line skeleton-animation"></div>
            <div className="skeleton-select skeleton-animation"></div>
            <div className="skeleton-button skeleton-animation"></div>
          </>
          :
          <>
            <h2 className="title">Select Trade Show Location</h2>
            <p className="helper-text">
              Please choose your location from the dropdown below.
            </p>
            <Select
              className="dropdown"
              placeholder="Select a location"
              onChange={handleCountryChange}
              options={locations}
              isSearchable={false}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  outline: "none",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#0abe75",
                  },
                  "&:focus": {
                    borderColor: "#0abe75",
                  },
                }),
                option: (styles) => {
                  return {
                    ...styles,
                    backgroundColor: "#fff",
                    color: "#000",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  };
                },
              }}
            />
            <button
              className={`continue-button ${selectedCountry ? "active" : "disabled"}`}
              onClick={handleContinue}
              disabled={!selectedCountry}
            >
              {showLoader ? <FetchLoader /> : <span>Continue</span>}
            </button>
          </>}
      </div>
    </div>
  );
}

